<div class="lesson-time-spent-label" tabindex="0" [attr.aria-label]="timeSpentinWords">
  <label class="lesson-time-spent-text">Time Spent:</label>
  <span class="lesson-time-spent-time"  >{{TimeStamp | sanitize }}</span>
</div>
<div class="iframe-height">
  <iframe name="StaticContentIFrame" class="kognito-iframe static-iframe" [src]="StaticContentIframe | safe" id="StaticContentIFrame"
    scrolling="yes" webkitallowfullscreen mozallowfullscreen
    allowfullscreen></iframe>
</div>
<div class="ehr-iframe-container ui-widget-content" [ngClass]="isMobile? 'ehr-iframe-container-devices':''" [@slideInOut]="IsLTIChildFrameVisible ? 'closed' : 'open'"  [style.width.px]='width'>
  <div class="grabber"></div>
  <iframe name="LTIChildFrame" title="LTIChild" id="LTIChildFrame" class="iframe-width100 chart-static-iframe" scrolling="no"
    [src]="StaticContentChildIframe | safe"></iframe>
</div>
